function Card({name, selection, selected, value, handleSelection, cardValue, isReveal, cardStyles, cardStyleSelected, customCardStyle, onClick}) {
  const isCardChoosen = !!cardValue;

  if (isReveal){    
    return (
      <div className={"card display reveal"}>
        <div className='card-name'>{cardValue}</div>
        <div className='card-name name-reveal'>{name}</div>
      </div>
    );
  }

  if (selection){
    return (
      <div onClick={() => handleSelection(value)} className={`card selection ${selected ? "selected": ""}`}>
        <div className='card-name'>{value}</div>
      </div>
    );
  } else {
    if (cardStyles === "custom" && isCardChoosen){
      return (
        <div
          onClick={onClick}
          className={`card display ${isCardChoosen ? "chosen": ""} ${cardStyles} ${cardStyleSelected ? "card-style-selected" : ""}`}
          style={{
            backgroundImage: `url(${customCardStyle.url})`,
            backgroundRepeat: customCardStyle.backgroundRepeat,
            backgroundSize: customCardStyle.backgroundSize + "%",
            backgroundPositionX: customCardStyle.backgroundPosition[0] + "%",
            backgroundPositionY: customCardStyle.backgroundPosition[1] + "%",
            animation: customCardStyle.backgroundAnimation,
            opacity: 1
          }}
        >
          <div className='card-name'>{name}</div>
        </div>
      );
    }
    return (
      <div
        onClick={onClick}
        className={`card display ${isCardChoosen ? "chosen": ""} ${cardStyles} ${cardStyleSelected ? "card-style-selected" : ""}`}
      >
        <div className='card-name'>{name}</div>
      </div>
    );
  }
}

Card.defaultProps = {
  name: "",
  selection: false,
  cardStyles: false,
  value: 0
};

export default Card;
